import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private cookieService: CookieService,
        private translateService: TranslateService,
        private notification: NzNotificationService,
    ) { }

    canActivate() {
        if (this.cookieService.get('token') && this.cookieService.get('token') !== '') {
            return true;
        }

        // not logged in so redirect to login page
        this.notification.create('error', this.translateService.instant('登录信息过期'),
          this.translateService.instant('请重新登录!'));
        this.router.navigate(['/login']);
        return false;
    }
}
